var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Reproductor',{attrs:{"msg":"Figuras geométricas","audio2":"../mp3/PrimariaB/06PB.mp3","cover":"../img/2.jpg","name":"Primaria B - Lección #6"}}),_c('Buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }